import { getMapStyle } from './map-style';
import { tableStyle } from './table-style';
import { paginationStyle, alertStyle } from './shared-styles-from-theme-fluent';
import type { CommonStylesPalette } from '../types.d';


const targetLocationRecommendationSharedStyle = ({ palette = {} as CommonStylesPalette }) => (Object.assign({
  '.location-recommendation-container': {
    '& .table>.header>tr>th': {
      padding: '8px 10px',
    },
    '& .table > colgroup + thead > tr:first-child > th': {
      borderTop: '0 !important',
    },
    '& .map-container-wrapper': {
      position: 'relative',
      zIndex: 0,
      ...getMapStyle(palette),
    },
    '& .dismiss-recommendation': {
      cursor: 'pointer',
    },
    '& .btn-primary': {
      marginRight: 10,
    },
    ...tableStyle({ palette }),
    ...paginationStyle({ palette }),
  },
}));

export const targetLocationRecommendationStyle = ({ palette = {} as CommonStylesPalette }) => ({
  '.location-recommendation-container': {
    padding: '12px 32px',
    borderBottom: '1px solid #edebe9',
    marginBottom: 0,
    extend: targetLocationRecommendationSharedStyle({ palette })['.location-recommendation-container'],
    '& .recommendation-light-bulb': {
      color: '#1470A5',
      display: 'inline-block',
      overflow: 'visible',
      background: '#EFF6FC',
      marginRight: '5px',
      paddingRight: '0px !important',
      '&:before': {
        content: "'\\F8F2'",
        lineHeight: '22px',
        fontFamily: 'MsAds MDL2 Assets',
        verticalAlign: 'top',
        fontSize: '14px',
      },
    },
    '& .alert.alert-recommendation': {
      background: '#EFF6FC',
      border: '1px solid #0078D4 !important',
      padding: '10px 32px 10px 8px !important',
      lineHeight: '16px !important',
      fontWeight: 600,
    },
    '& .location-recommendation-grid-container': {
      '& .grid-pager': {
        '& .pager': {
          display: 'inline-block',
          marginLeft: '15px',
        },
      },
    },
    '& .location-recommendation-body': {
      marginLeft: '-15px',
      '&.panel.collapse.in': {
        backgroundColor: '#fff',
        border: '1px solid transparent',
        borderRadius: '4px',
        boxShadow: 'none',
        margin: '0 0 0 -15px',
      },
      '& > .row > .col-sm-6': {
        width: '100%',
      },
    },
    '& .location-grid-container': {
      paddingBottom: '17px',
      '& .table>tbody>tr>td': {
        fontSize: '14px',
        lineHeight: '19px',
        padding: '22px 10px',
        verticalAlign: 'middle',
      },
    },
    ...alertStyle({ palette }),
  },
  '.inline-location-recommendation-container': {
    marginLeft: '-15px !important',
    extend: targetLocationRecommendationSharedStyle({ palette })['.location-recommendation-container'],
    '& .map-container-wrapper': {
      height: '479px',
    },
  },
  '.location-targets': {
    '& .alert-recommendation': {
      border: `1px solid ${palette.neutralSecondary} !important`,
      '& .alert-info-inline': {
        marginLeft: '0px',
      },
      margin: '3px 0',
    },
    '& .recommendation-light-bulb': {
      color: '#1470A5',
      overflow: 'visible',
      background: '#EFF6FC',
      '&:before': {
        content: "'\\F8F2'",
        lineHeight: '22px',
        fontFamily: 'MsAds MDL2 Assets',
        verticalAlign: 'top',
        fontSize: '14px',
      },
    },
  },
  '.location-manage-box': {
    '& .recommend-location-grid': {
      marginTop: '35px',
      marginRight: '-15px',
      marginLeft: '-15px',
      '& .location-recommend-grid-container': {
        marginBottom: '10px',
        '& .column-header:last-child': {
          paddingRight: 0,
          paddingLeft: 0,
          width: 85,
          textAlign: 'right',
        },
        '& tbody > tr > td': {
          border: '0px !important',
          '& .dismiss-recommendation': {
            width: '13px',
            color: palette.neutralSecondary,
            height: '12px',
            fontSize: '12px',
            textAlign: 'center',
            fontFamily: 'MsAds MDL2 Assets',
            lineHeight: '12px',
            cursor: 'pointer',
          },
        },
        '& .custormerInsightsLocation': {
          color: '#0078D4',
          overflow: 'visible',
          marginRight: '5px',
          fontSize: '16px',
          lineHeight: '14px',
          '&:before': {
            content: "'\\F8F4'",
            fontFamily: 'MsAds MDL2 Assets',
          },
        },
      },
      '& .alert .alert-info-inline': {
        marginLeft: '0px',
      },
      '& .alert.alert-recommendation': {
        background: '#EFF6FC',
        border: '1px solid #0078D4 !important',
        padding: '10px 32px 10px 12px !important',
        lineHeight: '16px !important',
        marginBottom: '16px',
      },
      '& input.target.btn.btn-primary': {
        background: '#FFFFFF',
        border: '1px solid #8A8886',
        boxSizing: 'border-box',
        borderRadius: '2px',
        color: '#323130',
        marginBottom: '39px',
      },
      '& .location-grid-container': {
        '& .table-container': {
          '& .row-selected>td': {
            background: '#EDEBE9',
            color: '#323130',
            fontWeight: '500',
          },
          '& .table>tbody>tr': {
            lineHeight: '19px',
            fontSize: '12px',
            height: '32px',
            color: '#797775',
          },
          '& .table>thead>tr>th': {
            height: '42px',
            lineHeight: '19px',
            border: 'none !important',
          },
        },
      },
      '& .recommendation-light-bulb': {
        color: '#0078D4',
        overflow: 'visible',
        background: '#EFF6FC',
        marginRight: '5px',
        paddingRight: '0px !important',
        '&:before': {
          content: "'\\EA80'",
          lineHeight: '22px',
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '16px',
        },
      },
    },
  },
  // TODO: Make this style local
  // ...glyphIconStyle({ palette, iconFontFamily }),
});
